"use client";

import React from "react";
import {
  Image as MantineImage,
  Modal as MantineModal,
  UnstyledButton as MantineUnstyledButton,
} from "@mantine/core";
import styles from "./styles.module.scss";

type ModalStyles = {
  inner?: React.CSSProperties;
  content?: React.CSSProperties;
  [key: string]: React.CSSProperties | undefined;
};

type Props = {
  isOpen: boolean;
  closeModal: () => void;
  children: React.ReactNode;
  zIndex?: number;
  styles?: ModalStyles;
};

const DEFAULT_MODAL_Z_INDEX = 9000;

const Modal = ({ isOpen, closeModal, zIndex, styles: customStyles, children }: Props) => {
  const resolvedZIndex = zIndex ?? DEFAULT_MODAL_Z_INDEX;
  const baseStyles: ModalStyles = {
    inner: {
      zIndex: resolvedZIndex,
    },
    overlay: {
      zIndex: resolvedZIndex,
    },
  };

  const mergedStyles: ModalStyles = customStyles
    ? {
        ...baseStyles,
        ...customStyles,
        inner: { ...baseStyles.inner, ...customStyles.inner } as React.CSSProperties,
        content: {
          border: "1px solid black",
          ...(customStyles.content as React.CSSProperties),
        },
      }
    : {
        ...baseStyles,
        content: { border: "1px solid black" },
      };

  return (
    <MantineModal
      opened={isOpen}
      onClose={closeModal}
      withCloseButton={false}
      centered={false}
      padding={0}
      size="xl"
      zIndex={resolvedZIndex}
      className={styles.modal}
      portalProps={{
        className: styles.portal,
        reuseTargetNode: false,
      }}
      styles={mergedStyles}
    >
      <MantineUnstyledButton
        onClick={closeModal}
        aria-label="Close modal"
        className={styles.closeButton}
      >
        <MantineImage src="/cross.svg" alt="Close" w={20} h={20} />
      </MantineUnstyledButton>
      {children}
    </MantineModal>
  );
};

export default Modal;
